import GetPostResponse from 'Global/Functions/GetPostResponse/GetPostResponse';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';

const useGetAccessList = (isTokenValid) => {
  const [roles, setRoles] = useState([]);
  const IdwebUser =
    Cookies.get('user') &&
    JSON.parse(Cookies.get('user'))?.Id;

  const AccessRoles = GetPostResponse(
    `${process.env.REACT_APP_API_URL_API_GET_USER_ACTION}`,
    true,
    {
      Id: IdwebUser,
    },
    null,
    isTokenValid
  )?.Data;

  // console.log('AccessRolesAccessRoles===>', AccessRoles);

  useEffect(() => {
    if (AccessRoles && isTokenValid) {
      setRoles(AccessRoles);
    }
  }, [AccessRoles, isTokenValid]);

  return roles;
};

export default useGetAccessList;
